import { useAction } from 'next-safe-action/hooks'

import { MessageType } from '@/shared/api'
import {
  useAirbridgeContext,
  useNetworkErrorHandler,
  useServerErrorHandler,
} from '@/shared/config'

import { requestRoomReview as _requestRoomReview } from './request-room-review/request'
import { TRequestRoomReviewEvent } from './request-room-review/schema'

type Props = {
  onSuccess?: () => void
}

export const useRequestRoomReview = ({ onSuccess }: Props = {}) => {
  const { handleServerError } = useServerErrorHandler()
  const { handleNetworkError } = useNetworkErrorHandler()
  const { sendEvent } = useAirbridgeContext()

  const sendAirbridgeEvent = ({
    airbridgeEvent,
  }: {
    airbridgeEvent: TRequestRoomReviewEvent
  }) => {
    const params = {
      action: airbridgeEvent.action,
      label: airbridgeEvent.label,
      value: airbridgeEvent.value,
      semanticAttributes: {
        isFirstPerUser: airbridgeEvent.isFirstPerUser,
        score: airbridgeEvent.score,
        products: [
          {
            currency: 'KRW',
            position: 1,
            productID: airbridgeEvent.productId,
            quantity: airbridgeEvent.quantity,
            price: airbridgeEvent.price,
          },
        ],
        currency: 'KRW',
      },
    }

    sendEvent({
      event: airbridgeEvent.eventName,
      params,
      onSuccess,
    })
  }

  const action = useAction(_requestRoomReview, {
    onError: ({ error }) => {
      if (error.serverError) {
        handleServerError(error.serverError)
      }
    },
  })

  const requestRoomReview = async (roomId: number) => {
    try {
      const res = await action.executeAsync({ roomId })

      if (res?.data?.airbridgeEvent) {
        sendAirbridgeEvent({
          airbridgeEvent: res.data.airbridgeEvent,
        })
      }
    } catch (error) {
      handleNetworkError({
        error,
        type: MessageType.ALERT,
        title: '잠시 후 다시 시도해 주세요',
        content:
          '예기치 못한 오류가 발생했습니다.\n지속적으로 발생할 경우 고객센터로 문의해 주세요.',
        confirmText: '확인',
      })
    }
  }

  return { requestRoomReview }
}
